import { CheckedChangedEventHandler } from '@sunwebgroup/ui-components'
import { Accordion, IconGlyph } from '@sunwebgroup/ui-components/uds'
import { equals, isEmpty, reject } from 'ramda'
import { useIntl } from '@/intl'
import { ShowMore } from '@/scopes/common/components/ShowMoreUDS'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createSearchFilterClickEvent } from '@/scopes/search/search/domain/analytics'
import { useMultiSelectFilter } from '../../../../domain/hooks'
import { FilterGroupProps } from '../types'
import ListFilterItem from './ListFilterItem'

function getIconFromValue(value: string): IconGlyph | undefined {
  if (value === 'APARTHOTEL')
    return 'House'
  if (value === 'APARTMENT')
    return 'AppartmentBuilding'
  if (value === 'BOUTIQUE_HOTEL')
    return 'House'
  if (value === 'BUNGALOW')
    return 'SmallHouse'
  if (value === 'CAMPING')
    return 'TipiTent'
  if (value === 'HOTEL')
    return 'Bed'
  if (value === 'CHALET')
    return 'Villa'
  if (value === 'HOLIDAYPARK')
    return 'Houses'
  if (value === 'GASTHOF')
    return 'House'
  return undefined
}

export function AccommodationTypeFilter({ defaultOpen }: FilterGroupProps) {
  const intl = useIntl()
  const { sendEvent } = useAnalytics()
  const { options, selectedValues, setSelection, isFetching } = useMultiSelectFilter('AccommodationType')

  const handleFilterChange: CheckedChangedEventHandler = ({ checked, value }) => {
    if (checked) {
      setSelection([...selectedValues, value])
      sendEvent(
        createSearchFilterClickEvent({
          element: 'checkbox',
          type: 'accomodation type',
          result: [...selectedValues, value].join(','),
        }),
      )
    }
    if (!checked) {
      setSelection(reject(equals(value), selectedValues))
    }
  }

  if (isEmpty(options))
    return null

  return (
    <Accordion.Item
      title={intl.formatMessage({ id: 'accommodation_type_label' })}
      defaultOpen={defaultOpen}
      data-qa="accommodation-type-filter"
    >
      <ShowMore
        openLabel={intl.formatMessage({ id: 'show_more' })}
        closeLabel={intl.formatMessage({ id: 'show_less' })}
      >
        {options.map(({ name, value, resultsCount }) => (
          <ListFilterItem.Checkbox
            key={name}
            label={name}
            counter={resultsCount}
            checked={selectedValues.includes(value)}
            value={value}
            disabled={isFetching}
            glyph={getIconFromValue(value)}
            onChange={handleFilterChange}
            data-qa="accommodation-type-filter-option"
            data-qa-value={value?.toLowerCase()}
          />
        ))}
      </ShowMore>
    </Accordion.Item>
  )
}
